// src/client/components/ContrastToggle.tsx
//
// #706 (gap-g5): 屋外向けの高コントラスト表示の手動切替 (header の言語切替の隣)。 押すたびに 通常 ⇄ 高コントラスト。
// 状態は aria-pressed と文字の両方で示す (色だけで伝えない)。 設定は端末ごと (lib/contrast.ts)。
// gap-i4: 現場スマホ (/m、 AppShell の外) の header にも同じ部品を置く (variant="field" = 指で押せる 48px の高さ)。

import { useState, type JSX } from "react";
import { useTranslation } from "react-i18next";
import { readContrast, saveContrast, type ContrastMode } from "../lib/contrast";

const CLASS = {
  header: "rounded-md border bg-background px-2 py-1 text-xs hover:bg-muted",
  field: "min-h-[48px] shrink-0 rounded-md border bg-background px-2 text-xs font-medium hover:bg-muted",
} as const;

export function ContrastToggle({ variant = "header" }: { readonly variant?: keyof typeof CLASS } = {}): JSX.Element {
  const { t } = useTranslation();
  const [mode, setMode] = useState<ContrastMode>(() => readContrast());
  const high = mode === "high";
  return (
    <button
      type="button"
      data-contrast-toggle
      aria-pressed={high}
      onClick={() => {
        const next: ContrastMode = high ? "normal" : "high";
        saveContrast(next);
        setMode(next);
      }}
      className={`${CLASS[variant]} focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-700`}
      title={t("a11y.contrast.hint")}
    >
      {high ? t("a11y.contrast.on") : t("a11y.contrast.off")}
    </button>
  );
}
